import { HTTPRequest, HTTPRequestConfig, HTTPRequestResponse } from '@bimser/common';

export class Fetch {
	get<T>(url: string, config?: HTTPRequestConfig): Promise<HTTPRequestResponse<T>> {
		const inst = new HTTPRequest(config);
		config = { baseURL: this.BaseUrl, ...config };
		return inst.get(url, config);
	}

	post<T>(url: string, data?: any, config?: HTTPRequestConfig): Promise<HTTPRequestResponse<T>> {
		const inst = new HTTPRequest(config);
		config = { baseURL: this.BaseUrl, ...config };
		return inst.post(url, data, config);
	}

	put<T>(url: string, data?: any, config?: HTTPRequestConfig): Promise<HTTPRequestResponse<T>> {
		const inst = new HTTPRequest(config);
		config = { baseURL: this.BaseUrl, ...config };
		return inst.put(url, data, config);
	}

	BaseUrl: string;
}
